module.exports = __webpack_public_path__ + "a9bc249723144f709de655f3f83aac94.svg";